<div class="size-selector">
    <ui-svg-icon
        icon="filter"
        (click)="openFilterList()"
        data-test-id="size-selector"></ui-svg-icon>
</div>
